import {createRouter, createWebHistory} from 'vue-router';
import {getUser} from './main'
import App from "@/App";
import {useEndpointStore} from "@/store/endpointStore";

const routes = [
    {
        path: '/',
        component: App,
        children: [
            {
                path: '/',
                name: 'nothing',
                beforeEnter() {location.href = 'https://www.esmo.org/newsroom/press-and-media-hub'}
            },
            {
                path: '/authentication',
                name: 'authentication',
                component: () => import('./components/common/Authentication')
            },
            {
                path: '/accreditation',
                name: 'accreditation',
                component: () => import('./components/Accreditation')
            },
            {
                path: '/accreditation/work',
                name: 'accreditation-work',
                component: () => import('./components/Accreditation')
            },
            {
                path: '/accreditation/terms-conditions',
                name: 'accreditation-terms-conditions',
                component: () => import('./components/Accreditation')
            },
            {
                path: '/join-network',
                name: 'join-network',
                component: () => import('./components/Registration')
            },
            {
                path: '/join-network/work',
                name: 'join-network-work',
                component: () => import('./components/Registration')
            },
            {
                path: '/profile-management',
                name: 'profile-management',
                component: () => import('./components/ProfileManagement')
            },
            {
                path: '/profile-management/work',
                name: 'profile-management-work',
                component: () => import('./components/ProfileManagement')
            },
            {
                path: '/multimedia-library',
                name: 'multimedia-library',
                component: () => import('./components/PressMediaGallery')
            },
            {
                path: '/accreditations',
                name: 'accreditations',
                component: () => import('./components/Accreditations')
            },
            {
                path: '/press-conference',
                name: 'press-conference',
                component: () => import('./components/PressConference')
            },
            {
                path: '/interview-request',
                name: 'interview-request',
                component: () => import('./components/InterviewRequest.vue'),
                meta: {
                    apiKey: "963e1a33-ceca-4423-bac1-f5c8de293681"
                }
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    if (to.matched.some(record => record.meta.apiKey != null)) {
        const  endpointStore =  useEndpointStore();
        endpointStore.setApiKey(to.meta.apiKey)
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (getUser() == null || getUser().token == null ) {
            next('/login')
            return
        }
    }
    if(to.fullPath.startsWith('/#')){
        next(to.fullPath.replaceAll('/#',''))
        return;
    }
    next()
});

export default router;